import { add, sum } from 'lodash';
import { PropTypes } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDialog } from '../../../core/actions';
import ModalDialog from '../../../core/components/Modal';
import { checkErrors } from '../../../core/formValidation';
import { getApiStatus } from '../../../core/utils';
import { generateToastr } from '../../../core/toastMessages';
import { parseNumber } from '../../../utils/number-util';
import * as actions from '../actions';
import { formatOrderDate } from '../helpers';
import PurchaseOrderFormWrapper from '../components/PurchaseOrderFormWrapper';
import { selectAdditionalCost, selectSubTotal } from '../purchaseOrderReducer';

const PurchaseOrderDialog = (props) => {
  const formRef = React.useRef(null);
  const onReady = () => {
    if (formRef.current && formRef.current.submit) {
      formRef.current.submit();
    }
  };
  const formatItems = (items) => {
    return items.map((item) => {
      return {
        name: item.name,
        quantity: Number(item.quantity),
        price: `${parseNumber(item.price)}`,
      };
    });
  };
  const checkValid = (value) => {
    if (
      !value.categoryId ||
      isNaN(value.categoryId) ||
      !value.employeeId ||
      isNaN(value.employeeId) ||
      !value.vendorId ||
      isNaN(value.vendorId)
    ) {
      generateToastr('error', 'Invalid Field', 'Please select all required options', {
        timeOut: 5000,
      });
      return false;
    }
    const formTotal = add(sum(props.itemCosts), props.additionalCost) || 0;
    if (formTotal - parseFloat(value.discount || 0) < 0) {
      generateToastr('error', 'Invalid Value', 'Discount cannot reduce the Total below zero', {
        timeOut: 5000,
      });
      return false;
    }

    return true;
  };

  const onSubmit = (values) => {
    const newValues = {
      id: values.id,
      categoryId: Number(values.categoryId),
      discount: `${parseNumber(values.discount)}`,
      employeeId: Number(values.employeeId),
      items: formatItems(values.items),
      orderDate: formatOrderDate(values.orderDate),
      shippingAmount: `${parseNumber(values.shippingAmount)}`,
      taxAmount: `${parseNumber(values.taxAmount)}`,
      trackingNumber: values.trackingNumber,
      memo: values.memo,
      vendorId: Number(values.vendorId),
    };
    if (checkValid(newValues)) {
      if (props.isNew) {
        props.addPurchaseOrder(newValues, props.callback);
      } else {
        // editPurchaseOrder now uses voidCallback, so we call the callback directly
        const voidCallback = () => {
          if (props.callback) {
            props.callback();
          }
        };
        props.editPurchaseOrder(newValues, voidCallback);
      }
    }
  };

  const submitDisabled = false; // RHF handles validation inside the form
  const title = props.isNew ? 'Add Purchase Order' : 'Edit Purchase Order';
  return (
    <ModalDialog
      title={title}
      onReady={onReady}
      isOpen={props.isOpen}
      close={props.hideDialog}
      disabled={submitDisabled}
      isSubmitting={props.isSubmitting}
      className="enhanced-dialog narrow padded-minimal"
    >
      <PurchaseOrderFormWrapper ref={formRef} {...props} onSubmit={onSubmit} />
    </ModalDialog>
  );
};

PurchaseOrderDialog.propTypes = {
  addPurchaseOrder: PropTypes.func.isRequired,
  editPurchaseOrder: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  hideDialog: PropTypes.func.isRequired,
  initialValue: PropTypes.shape({}), // eslint-disable-line
  isNew: PropTypes.bool,
  callback: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    itemCosts: selectSubTotal(state),
    additionalCost: selectAdditionalCost(state),
    isSubmitting:
      getApiStatus(state, actions.ADD_PURCHASE_ORDER) ||
      getApiStatus(state, actions.EDIT_PURCHASE_ORDER),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      addPurchaseOrder: actions.addPurchaseOrder,
      editPurchaseOrder: actions.editPurchaseOrder,
      hideDialog,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderDialog);
